import { Loader } from '@/components/common/loader';
import { MultidietPickerCarousel } from '@/features/multidiet-picker/components/multidiet-picker-carousel';
import { MultidietVariantsItem } from '@/features/multidiet-picker/components/multidiet-variants-item';
import useMultidietSetupStore from '@/features/multidiet-picker/store/multidiet-picker.store';
import { MultidietSetupVariantType } from '@/features/multidiet-picker/types/multidiet-setup.type';

export const MultidietVariants = ({
  layout,
  multidietSetupLabels,
}: {
  layout: 'page' | 'popup';
  multidietSetupLabels: MultidietSetupVariantType[];
}) => {
  const { isFetching } = useMultidietSetupStore();

  return (
    <div className='relative'>
      {isFetching && (
        <div className='absolute inset-0 z-10 flex items-center justify-center bg-white/50'>
          <Loader />
        </div>
      )}
      <div className='hidden xl:block '>
        <div className='flex gap-3 items-center'>
          {multidietSetupLabels?.map((variant) => {
            return (
              <MultidietVariantsItem
                key={variant.type + variant.calories}
                layout={layout}
                variant={variant}
                isBestOffer={variant.type === 'STANDARD'}
                size={variant.type === 'STANDARD' ? 'large' : 'small'}
              />
            );
          })}
        </div>
      </div>
      <div className='lg:flex gap-3 items-center xl:hidden w-full '>
        {multidietSetupLabels && (
          <MultidietPickerCarousel
            layout={layout}
            variants={multidietSetupLabels}
          />
        )}
      </div>
    </div>
  );
};
